import type { UcFeaturesSection } from '../../../lib/useCaseQueries';
import { UseCaseBand } from '../primitives';
import { UseCaseSectionHead } from '../UseCaseSectionHead';

type UcFeaturesSectionProps = {
  data: UcFeaturesSection;
  tone: 'light' | 'dark';
};

export function UcFeaturesSection({ data, tone }: UcFeaturesSectionProps) {
  return (
    <UseCaseBand tone={tone} id="features" className="feat-section">
      <UseCaseSectionHead eyebrow={data.eyebrow} heading={data.heading} />
      <div className="feat-grid reveal">
        {(data.features ?? []).map((feature, index) => (
          <div key={feature.title} className="feat-tile">
            <div className="ft-n">
              <span className="line" aria-hidden="true" />
              <span>{String(index + 1).padStart(2, '0')}</span>
            </div>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </UseCaseBand>
  );
}
